import React from 'react';
import PropTypes from "prop-types";
import styled from 'styled-components';
import ClearIcon from '../../components/icons/ClearIcon';

const sampleShirtImage = '/images/builder/shirtCatalogSample.png'

const CloseButton = styled.button`
    padding: 5px;
    margin: auto 10px auto auto;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
    cursor: pointer;
    outline: none;
`

const ProductPreview = ({ imgSrc, changePreview, zoomToggle, zoomMode, getCatalogImageUrl, isMobile }) => {
    const [index, setIndex] = React.useState(0);
    const [initialClientX, setInitialClientX] = React.useState(0);
    const [finalClientX, setfinalClientX] = React.useState(0);
    const [images, setImages] = React.useState([]);
    const imgIndexes = [0, 1, 2, 3];

    const getSmallImgSrc = (index) => {
        return index === 0 ? 
            getCatalogImageUrl('small', true) :
            getCatalogImageUrl('small', false, index)
    }

    const checkImage = (imageSrc, onLoad, onError) => {
        var img = new Image();
        img.onload = onLoad; 
        img.onerror = onError;
        img.src = imageSrc;
    }

    React.useEffect(() => {
        imgIndexes.forEach(index => {
            checkImage(
                getSmallImgSrc(index), 
                () => {
                    if(!images.includes(index)) {
                        setImages([...images, index])
                    }
                },
                () => { /* if image exist */})
        })
    });


    const onImageError = (e) => {
        e.target.src = sampleShirtImage;
    }

    const onImageErrorHide = (e) => {
        e.target.style.display = 'none';
    }

    const handleClick = (action) => {
        let imageIndex = index;
        const imageLastIndex = images[images.length - 1];
        let indexInArray = images.indexOf(imageIndex);

        if (action === 'prev') {
          if (indexInArray === 0) {
            imageIndex = imageLastIndex;
          } else {
            imageIndex = images[--indexInArray];
          }
        }
        if (action === 'next') {
          if (indexInArray === images.length - 1) {
            imageIndex = 0;
          } else {
            imageIndex = images[++indexInArray];
          }
        }

        if(!images.includes(imageIndex)) {
            return false;
        }

        setIndex(imageIndex);
        changePreview(imageIndex);
    }

    const handleTouchStart = (e) => {
        setInitialClientX(e.nativeEvent.touches[0].clientX)
    }

    const handleTouchMove = (e) => {
        setfinalClientX(e.nativeEvent.touches[0].clientX)
    }

    const handleTouchEnd = () => {
        if (finalClientX < initialClientX) {
            handleClick('next');
        }

        if (finalClientX > initialClientX) {
            handleClick('prev');
        }

        setInitialClientX(0)
        setfinalClientX(0)
    }

    const onRenderPreview = (src) => {
        return (
            <img 
                className='b-rit-product-page__preview-img'
                onClick={isMobile ? ()=>{} : zoomToggle}
                src={src}
                onError={onImageError}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                />
        )
    }

    if(zoomMode && !isMobile) {
        return (
            <div className='b-rit-product-page b-rit-product-page__zoom'>
                <div className='b-rit-product-page__zoom-bar'>
                    <div className="b-rit-product-page__zoom-item">
                        {images.sort().map((number, i) => (
                            <img 
                                key={i}
                                src={getSmallImgSrc(number)}
                                onClick={() => {changePreview(number); setIndex(number)}}
                                onError={onImageErrorHide}
                                alt="" />
                        ))}
                    </div>
                    <CloseButton
                        onClick={zoomToggle}>
                        <ClearIcon size={16} />
                    </CloseButton>
                </div>
                <div className='b-rit-product-page__zoom-preview' onClick={zoomToggle}>
                    {onRenderPreview(imgSrc)}
                </div>
            </div>
        )
    }

    return (
        <div className='b-rit-product-page__preview-img-wrapper'>
            {!isMobile && <div className="b-rit-product-page__preview-choise">
                {images.sort().map((number, i) => (
                    <img 
                        key={i}
                        src={getSmallImgSrc(number)}
                        onClick={() => {changePreview(number); setIndex(number)}}
                        className={index === number ? 'b-rit-product-page__preview-choise_selected' : ''}
                        onError={onImageErrorHide}
                        alt="" />
                ))}
            </div>}
            {onRenderPreview(imgSrc)}
            {isMobile && <div className="b-rit-product-page__preview-choise-state">
                <ul>
                    {images.sort().map(item => <li key={item} className={index === item ? 'current' : ''}></li>)}
                </ul>
            </div>}
        </div>
    )
}

ProductPreview.propTypes = {
    imgSrc: PropTypes.string.isRequired, 
    changePreview: PropTypes.func.isRequired, 
    zoomToggle: PropTypes.func.isRequired, 
    zoomMode: PropTypes.bool.isRequired, 
    getCatalogImageUrl: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
}

export default ProductPreview;